import { render, staticRenderFns } from "./UpgradeClassRoom.vue?vue&type=template&id=16fc0e3e"
import script from "./UpgradeClassRoom.vue?vue&type=script&lang=js"
export * from "./UpgradeClassRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports